import { render, staticRenderFns } from "./myFirstDayTW.vue?vue&type=template&id=1996aa24&scoped=true"
import script from "./myFirstDayTW.vue?vue&type=script&lang=js"
export * from "./myFirstDayTW.vue?vue&type=script&lang=js"
import style0 from "./myFirstDayTW.vue?vue&type=style&index=0&id=1996aa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996aa24",
  null
  
)

export default component.exports